// extracted by mini-css-extract-plugin
export default {"timer":"ReqCounter_timer__gJNHY","time":"ReqCounter_time__fMAwA"};